import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, map, Subject, tap } from 'rxjs';
import { M30 } from '../../models/m30';
import { DataService } from '../../data.service';

@Component({
  selector: 'app-page-m30',
  templateUrl: './page-m30.component.html',
  styleUrls: ['./page-m30.component.scss']
})
export class PageM30Component implements OnInit {

  /** null: not yet loaded */
  allM30$ = new BehaviorSubject<M30[] | null>(null);

  hasPrivilege$ = this.allM30$.pipe(
    map(m30s => m30s ? m30s.length > 0 : true),
    tap(x => console.log('hasPrivilege$', x))
  )

  ngOnInit(): void {
  }


}

